import { memo, useState } from "react";
import { Box, Typography } from "@mui/material";
import AddCircle from "../assets/icons/add-circle.svg";
import CloseCircle from "../assets/icons/close-circle.svg";
import Cartoon from "../assets/filters/cartoon.png";
import Night from "../assets/filters/night.png";
import Plastic from "../assets/filters/plastic.png";

const Filters = ({ selectedFilter, setSelectedFilter }) => {
  const [filters] = useState([
    "checkboxFilterCartoon",
    "checkboxFilterPlastic",
    "checkboxFilterNight",
  ]);
  const [isOpenFilters, setIsOpenFilters] = useState(false);

  const handleFilterSelection = (filter) => {
    if(selectedFilter === filter) {
      setSelectedFilter(null);
      return;
    }
    setSelectedFilter(filter);
  };

  const getFilterImage = (val) =>
    ({
      checkboxFilterPlastic: Plastic,
      checkboxFilterCartoon: Cartoon,
      checkboxFilterNight: Night,
    }[val]);

  return (
    <Box
      sx={{
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#000000",
        paddingX: "16px",
        paddingY: "14px",
        backgroundColor: "#ffffff",
        width: "100%",
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => setIsOpenFilters((prev) => !prev)}
      >
        <Typography
          sx={{
            color: "rgba(110,90,180, 1)",
            fontWeight: "500",
            fontSize: "36px",
            marginRight: "12px",
          }}
        >
          FILTER
        </Typography>
        {isOpenFilters ? (
          <img
            src={CloseCircle}
            alt="close-circle"
            style={{ width: "35px", height: "35px" }}
          />
        ) : (
          <img
            src={AddCircle}
            alt="add-circle"
            style={{ width: "35px", height: "35px" }}
          />
        )}
      </Box>
      <Box
        sx={{
          overflowY: "hidden",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "20px",
          marginBottom: isOpenFilters ? "10px" : "0px",
          marginTop: isOpenFilters ? "10px" : "0px",
          transition: "all 0.5s ease",
          height: isOpenFilters ? "238px" : "0px",
        }}
      >
        {filters.map((filter) => {
          return (
            <Box
              key={filter}
              sx={{ position: "relative", cursor: "pointer" }}
              onClick={() => handleFilterSelection(filter)}
            >
              <Box
                style={{
                  transition: "all 0.3s ease",
                  opacity: selectedFilter !== filter ? 1 : 0,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  backgroundColor: "rgba(0,0,0,0.75)",
                }}
              />
              <img
                src={getFilterImage(filter)}
                alt="template"
                style={{ width: "200px", heigth: "215px" }}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default memo(Filters);
